export function toast(message: string, classification: 'alert' | 'notice', targetQuerySelector = '#flash', customClass: string | null = null) {
  const element = document.createElement('div');
  if (customClass) {
    element.classList.add(...customClass.split(' '));
  }
  element.setAttribute('x-data', '{open: true}');
  element.setAttribute('x-show', 'open');
  element.setAttribute('x-transition:enter', 'transition ease-out duration-300');
  element.setAttribute('x-transition:enter-start', 'opacity-0 scale-90');
  element.setAttribute('x-transition:enter-end', 'opacity-100 scale-100');
  element.setAttribute('x-transition:leave', 'transition ease-in duration-300');
  element.setAttribute('x-transition:leave-start', 'opacity-100 scale-100');
  element.setAttribute('x-transition:leave-end', 'opacity-0 scale-90');
  element.setAttribute('x-init', 'setTimeout(() => {open = false; setTimeout(() => {$el.remove()}, 1000) }, 3000)');

  let icon = '';
  if (classification === 'alert') {
    icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="stroke-current flex-shrink-0 w-6 h-6"><circle cx="12" cy="12" r="11.5" style="fill:#fff"/><path d="M10.721 4.547h2.659v9.741h-2.659z" style="fill:#f66f6f"/><path d="M10.65 16.331h2.614v3.092H10.65z" style="fill:#f66f6f"/></svg>';
  } else {
    icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-shrink-0 w-6 h-6"><circle cx="12" cy="12" r="11.5" style="fill:#fff"/><path d="M4.7 12.4s5.619 5.9 5.9 5.9c.281 0 9-9.9 9-9.9.53-.794-.606-2.094-1.4-1.3l-7.6 8L6.5 11c-.978-1.069-2.796.113-1.8 1.4Z" style="fill:#77d6bf"/></svg>';
  }
  element.innerHTML = `
      <div class="alert alert-${classification === 'alert' ? 'error' : 'success' } mt-0 text-white whitespace-normal">
        <div class="flex items-center text-start">
          ${icon}
          <span class="pl-2 whitespace-pre-line"></span>
        </div>
      </div>
  `;

  element.querySelector('span')!.textContent = message;

  const flashTarget = document.querySelector(targetQuerySelector);
  if (flashTarget) {
    flashTarget.append(element);

    return true;
  }

  return false;
}
